import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from 'moment';

@Component({
    selector: 'app-book',
    templateUrl: './book.component.html',
    styleUrls: ['./book.component.css']
})

export class BookComponent implements OnInit {
    @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
    Submitted: boolean = false;
    BookTypeList = [];
    AccList = [];
    BookTitlelist = [];
    AuthorList = [];
    PublicationList = [];
    BookEdditionList = [];
    SubjectList = [];
    LanguageList = [];
    BookStatus: any
    CheckACCNoList = [];
    CheckACCNoAlert: any;
    CheckCallNoList = [];
    CheckCallNoAlert: any;
    CheckISBNList = [];
    CheckISBNAlert: any;
    CheckNoofCopiesList = [];
    ItemType: any;
    PublicationLocationList = [];
    PublicationYearList = [];
    LibraryType: any;
    Frequency: any;
    BookList1 = [];
    BookGroup: any;
    YearList = [];


    constructor(private libraryservice: LibraryService, private lookupservice: LookupService, public globalHelper: GlobalHelper,
        private spinnerService: Ng4LoadingSpinnerService) { }

    currentPage = 1;
    pageSize = 20;
    recordCount = 0;
    totalPages = 0;

    numberOfPages() {

        this.totalPages = Math.ceil(this.recordCount / this.pageSize);
    }

    nextPage() {
        this.currentPage = this.currentPage + 1;

    }

    BookMSTModel = {
        Frequency: '',
        IsReference: false,
        IsIssuable: false,
        LanguageID: 0,
        SubjectID: 0,
        PublicationLocationID: 0,
        VolumeNo: '',
        IssueNo: '',
        BookType: '',
        FrequencyID: 0,
        PublicationYear: '',
        ItemTypeID: 1,
        BookStatusID: 0,
        BookTitleID: 0,
        BookGroupID: 0,
        AuthorID: 0,
        IsActive: true,
        PublicationID: 0,
        BookTypeID: 0,
        BookEdditionID: 0,
        LibraryTypeID: 0,
        BookEddition: '',
        BookSerialNo: '',
        BookSerialID: 0,
        CallNo: '',
        BookTitle: '',
        AuthorName: '',
        Publication: '',
        PublicationLocation: '',
        NoOfCopies: 0,
        ISBN: '',
        NoOfPages: 0,
        Cost: 0,
        Subject: '',
        Language: '',
        Series: '',
        ShelfLocation: '',
        Remarks: '',
        BillNo: '',
        BillDate: '',
        PublicationYearID: 0,


    }

    Clear() {
        this.Submitted = false;
        this.BookMSTModel.BookSerialNo = '';
        this.BookMSTModel.BookSerialID = 0;
        this.BookMSTModel.CallNo = '';
        this.BookMSTModel.BookTitle = '';
        this.BookMSTModel.AuthorName = '';
        this.BookMSTModel.Publication = '';
        this.BookMSTModel.PublicationLocation = '';
        this.BookMSTModel.PublicationYear = '';
        this.BookMSTModel.BookEddition = '';
        this.BookMSTModel.NoOfCopies = 0;
        this.BookMSTModel.ISBN = '';
        this.BookMSTModel.NoOfPages = 0;
        this.BookMSTModel.Cost = 0;
        this.BookMSTModel.Subject = '';
        this.BookMSTModel.Language = '';
        this.BookMSTModel.Series = '';
        this.BookMSTModel.ShelfLocation = '';
        this.BookMSTModel.Remarks = '';
        this.BookMSTModel.BookStatusID = 1;
        this.BookMSTModel.BillNo = '';
        this.BookMSTModel.BillDate = '';
        this.BookMSTModel.BookTitleID = 0;
        this.BookMSTModel.Cost = 0;
        this.BookMSTModel.AuthorID = 0;
        this.BookMSTModel.PublicationID = 0;
        this.BookMSTModel.BookTypeID = 0;
        this.BookMSTModel.LibraryTypeID = 0;
        this.BookMSTModel.IsActive = true;
        this.BookMSTModel.BookEdditionID = 0;
        this.BookMSTModel.PublicationID = 0;
        this.BookMSTModel.PublicationYearID = 0;
    }

    pageSizes() {
        this.currentPage = 1;
        this.recordCount = 0;
        this.totalPages = 0;

    }

    FilterModel = {
        BookTypeID:0,
        ItemTypeID: 1,
        CurrentIndex: 0,
        PageSize: 20,
        BookSerialNo: '',
        BookTitle: '',
        AuthorName: '',
        Publication: '',
        LibraryTypeID: 0,
        Subject: '',
        Language: '',
    }


    BookMSTList = [];
    GetAllBookType(ItemTypeID) {
        var itembi = {
            ItemId: ItemTypeID
        }
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('BookType', JSON.stringify(itembi)).subscribe((data: any) => {
            this.BookTypeList = data.LookupItems;
            this.spinnerService.hide();
        });
    };

    SelectedBookType($item) {
        this.BookMSTModel.BookTypeID = $item.ItemId;
        this.BookMSTModel.BookType = $item.ItemName;
    }

    Validation() {

        return this.BookMSTModel.LibraryTypeID == 0 || this.BookMSTModel.BookSerialNo != '' || this.BookMSTModel.BookTitle != '' || this.BookMSTModel.AuthorName != ''
            || this.BookMSTModel.Publication != ''


    }
    BValidation() {

        return this.BookMSTModel.LibraryTypeID != 0 || this.BookMSTModel.BookSerialNo != '' || this.BookMSTModel.BookTitle != '' || this.BookMSTModel.AuthorName != ''
            || this.BookMSTModel.Publication != '';


    }
    JValidation() {

        return this.BookMSTModel.LibraryTypeID == 0 || this.BookMSTModel.BookSerialNo != '' || this.BookMSTModel.BookTitle != '' || this.BookMSTModel.VolumeNo != ''
            || this.BookMSTModel.Publication != '' || this.BookMSTModel.IssueNo != ''


    }

    GetCommaAccNo() {
        this.AccList = [];
        var AccArray = this.BookMSTModel.BookSerialNo.split(',');
        for (var i = 0; i < AccArray.length; i++) {
            AccArray[i] = AccArray[i].replace(/^\s*/, "").replace(/\s*$/, "");
            var model = {
                'BookSerialNo': AccArray[i]
            }
            this.AccList.push(model);
        }

    }

    SaveBookMST(valid) {

        this.Submitted = true;
        this.BookMSTModel.BillDate = this.BookMSTModel.BillDate != null && this.BookMSTModel.BillDate != '' ? moment(this.BookMSTModel.BillDate).format('DD-MMM-YYYY') : '';

        if (this.BookMSTModel.ItemTypeID == 3) {
            if (!this.Validation() && valid) {
                this.GetCommaAccNo();
                this.spinnerService.show();
                this.libraryservice.SaveBookMST(JSON.stringify(this.BookMSTModel), JSON.stringify(this.AccList)).subscribe((response: any) => {
                    this.Submitted = false;
                    this.spinnerService.hide();
                    this.globalHelper.CheckActionStatus(response);
                    this.GetAllBook();
                    this.Clear();
                })
            }
        }
        else if (this.BookMSTModel.ItemTypeID == 2) {

            if (this.JValidation() && valid) {
                this.GetCommaAccNo();
                this.spinnerService.show();
                this.libraryservice.SaveBookMST(JSON.stringify(this.BookMSTModel), JSON.stringify(this.AccList)).subscribe((response: any) => {
                    this.Submitted = false;
                    this.spinnerService.hide();

                    this.globalHelper.CheckActionStatus(response);
                    this.GetAllBook();
                    this.Clear();
                })
            }



        }
        else if (this.BookMSTModel.ItemTypeID == 1) {
            if (this.BValidation() && valid) {
                this.GetCommaAccNo();
                this.spinnerService.show();
                this.libraryservice.SaveBookMST(JSON.stringify(this.BookMSTModel), JSON.stringify(this.AccList)).subscribe((response: any) => {
                    this.Submitted = false;
                    this.spinnerService.hide();
                    this.globalHelper.CheckActionStatus(response);
                    this.GetAllBook();
                    this.Clear();
                })
            }



        }
    }

    SelectedBookTitle($item) {
        this.BookMSTModel.BookTitleID = $item.ItemId;
        // this.BookMSTModel.BookTitle = $item.ItemName;
        this.GetCheckNoofCopies();
       
    }

    GetBookTitle(BookTitle) {
        this.BookTitlelist = [];
        var itembi = {
            ItemCode1: BookTitle
        }
        this.BookTitlelist = [];
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('BookTitle', JSON.stringify(itembi)).subscribe((data: any) => {
            this.BookTitlelist = data.LookupItems;
            this.BookTitlelist.splice(0, 1)
            this.spinnerService.hide();
        });
        return this.BookTitlelist;
    };

    SelectedAuthor($item) {

        this.BookMSTModel.AuthorID = $item.ItemId;
        // this.BookMSTModel.AuthorName = $item.ItemName;
        this.GetCheckNoofCopies();
    }
    GetAllAuthor(m) {
        var itembi = {
            ItemCode1: m,
        }
        this.AuthorList = [];
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('Author', JSON.stringify(itembi)).subscribe((data: any) => {
            this.AuthorList = data.LookupItems;
            this.AuthorList.splice(0, 1)
            this.spinnerService.hide();
        });
    };

    SelectedPublication($item) {
        this.BookMSTModel.PublicationID = $item.ItemId;
        // this.BookMSTModel.Publication = $item.ItemName;
        this.GetCheckNoofCopies();
    }
    GetAllPublication(m) {
        var itembi = {
            ItemCode1: m,
        }
        this.PublicationList = [];
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('Publication', JSON.stringify(itembi)).subscribe((data: any) => {
            this.PublicationList = data.LookupItems;
            this.PublicationList.splice(0, 1)
            this.spinnerService.hide();
        });


    };

    SelectedPublicationLocation($item) {
        this.BookMSTModel.PublicationLocationID = $item.ItemId;
        // this.BookMSTModel.PublicationLocation = $item.ItemName;
        this.GetCheckNoofCopies();
    }
    GetAllPublicationLocation(m) {
        var itembi = {
            ItemCode1: m,
        }
        this.PublicationLocationList = [];
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('PublicationLocation', JSON.stringify(itembi)).subscribe((data: any) => {
            this.PublicationLocationList = data.LookupItems;
            this.PublicationLocationList.splice(0, 1)
            this.spinnerService.hide();
        });


    };
    SelectedPublicationYear = function ($item) {
        this.BookMSTModel.PublicationYearID = $item.ItemId;
        // this.BookMSTModel.PublicationYear = $item.ItemName;
        this.GetCheckNoofCopies();
    }
    GetAllPublicationYear(m) {
        var itembi = {
            ItemCode1: m,
        }
        this.PublicationYearList = [];
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('PublicationYear', JSON.stringify(itembi)).subscribe((data: any) => {
            this.PublicationYearList = data.LookupItems;
            this.PublicationYearList.splice(0, 1)
            this.spinnerService.hide();
        });


    };
    SelectedBookEddition($item) {
        this.BookMSTModel.BookEdditionID = $item.ItemId;
        //   this.BookMSTModel.BookEddition = $item.ItemName;
        this.GetCheckNoofCopies();
    }
    GetAllBookEddition(m) {
        var itembi = {
            ItemCode1: m,
        }
        this.BookEdditionList = [];
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('BookEddition', JSON.stringify(itembi)).subscribe((data: any) => {
            this.BookEdditionList = data.LookupItems;
            this.BookEdditionList.splice(0, 1)
            this.spinnerService.hide();
        });


    };
    SelectedSubject($item) {
        this.BookMSTModel.SubjectID = $item.ItemId;
        // this.BookMSTModel.Subject = $item.ItemName;
    }
    GetAllSubject(m) {
        var itembi = {
            ItemCode1: m,
        }
        this.SubjectList = [];
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('LIBSubject', JSON.stringify(itembi)).subscribe((data: any) => {
            this.SubjectList = data.LookupItems;
            this.SubjectList.splice(0, 1)
            this.spinnerService.hide();
        });


    };
    SelectedLanguage($item) {
        this.BookMSTModel.LanguageID = $item.ItemId;
        // this.BookMSTModel.Language = $item.ItemName;
    }
    GetAllLanguage(m) {
        var itembi = {
            ItemCode1: m,
        }
        this.LanguageList = [];
        this.lookupservice.GetLookupsList('Language', JSON.stringify(itembi)).subscribe((data: any) => {
            this.LanguageList = data.LookupItems;
            this.LanguageList.splice(0, 1)
        });


    };


    GetAllBookStatus() {
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('BookStatus', '').subscribe((data: any) => {
            this.BookStatus = data.LookupItems;
            this.BookMSTModel.BookStatusID = 1;
            this.spinnerService.hide();
        });
    };

    GetCheckACCNo() {
        var itembi = {
            ItemCode1: this.BookMSTModel.BookSerialNo,
        }
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('CheckACCNo', JSON.stringify(itembi)).subscribe((data: any) => {
            this.CheckACCNoList = data.LookupItems;
            if (this.CheckACCNoList.length > 1) {
                this.CheckACCNoAlert = 'Acc No already exists';
            }
            this.spinnerService.hide();
        });
    };
    GetCheckCallNo() {
        var itembi = {
            ItemCode1: this.BookMSTModel.CallNo,
        }
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('CheckCallNo', JSON.stringify(itembi)).subscribe((data: any) => {
            this.CheckCallNoList = data.LookupItems;
            if (this.CheckCallNoList.length > 1) {
                this.CheckCallNoAlert = 'Call No already exists';
            }
            this.spinnerService.hide();
        });
    };
    GetCheckISBN() {
        var itembi = {
            ItemCode1: this.BookMSTModel.ISBN,
        }
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('CheckISBN', JSON.stringify(itembi)).subscribe((data: any) => {
            this.CheckISBNList = data.LookupItems;
            if (this.CheckISBNList.length > 1) {
                this.CheckISBNAlert = 'ISBN already exists';
            }
            this.spinnerService.hide();
        });
    };
    GetCheckNoofCopies() {
        var itembi = {
            ItemId: this.BookMSTModel.BookTitleID,
            ItemId1: this.BookMSTModel.AuthorID,
            ItemId2: this.BookMSTModel.PublicationID,
            ItemId3: this.BookMSTModel.PublicationLocationID,
            ItemId4: this.BookMSTModel.PublicationYearID,
            ItemId5: this.BookMSTModel.BookEdditionID
        }
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('CheckNoofCopies', JSON.stringify(itembi)).subscribe((data: any) => {
            this.CheckNoofCopiesList = data.LookupItems;
            if (this.CheckNoofCopiesList.length > 1) {
                this.BookMSTModel.NoOfCopies = this.CheckNoofCopiesList[1].ItemId;
            }
            this.spinnerService.hide();
        });
    };

    GetItemType() {
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('ItemType', '').subscribe((data: any) => {
            this.ItemType = data.LookupItems;
            this.spinnerService.hide();
        });
    };

    GetAllLibrary() {
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('LibraryType', '').subscribe((data: any) => {
            this.LibraryType = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetAllFrequency() {
        this.spinnerService.hide();
        this.lookupservice.GetLookupsList('Frequency', '').subscribe((data: any) => {
            this.Frequency = data.LookupItems;
            this.spinnerService.hide();
        });
    };
    GetStatus(item) {

        return item == true ? 'Yes' : 'No'
    }


    ClearFilter() {
          this.FilterModel.LibraryTypeID = 0;
          this.FilterModel.BookTypeID = 0;
        this.FilterModel.BookSerialNo = '';
        this.FilterModel.BookTitle = '';
        this.FilterModel.AuthorName = '';
        this.FilterModel.Publication = '';
        this.FilterModel.Subject = '';
        this.FilterModel.Language = '';
        this.SearchBook();
    }


    SearchBook() {
        this.currentPage = 1;
        this.GetAllBook();
    }
    GetAllBook() {

        this.FilterModel.CurrentIndex = this.currentPage;
        this.FilterModel.PageSize = this.pageSize;
        this.spinnerService.show();
        this.libraryservice.GetAllBookMST(JSON.stringify(this.FilterModel)).subscribe((response: any) => {
            this.BookList1 = response.BookList1;
            this.spinnerService.hide();
            this.recordCount = 0;
            if (this.BookList1 != null && response.BookList1.length > 0) {
                this.recordCount = this.BookList1[0].RecordCount;
            }
            this.numberOfPages();
            this.globalHelper.CheckActionStatus(response);

        });

    }

    Edit(obj) {

        this.BookMSTModel.BookSerialID = obj.BookSerialID;
        this.BookMSTModel.CallNo = obj.CallNo;
        this.BookMSTModel.ISBN = obj.ISBN;
        this.BookMSTModel.Language = obj.Language;
        this.BookMSTModel.LanguageID = obj.LanguageID;
        this.BookMSTModel.IsIssuable = obj.IsIssuable;
        this.BookMSTModel.IsReference = obj.IsReference;
        this.BookMSTModel.ItemTypeID = obj.ItemTypeID;
        this.BookMSTModel.FrequencyID = obj.FrequencyID;
        this.BookMSTModel.Frequency = obj.Frequency;
        this.BookMSTModel.IssueNo = obj.IssueNo;
        this.BookMSTModel.VolumeNo = obj.VolumeNo;
        this.BookMSTModel.BookStatusID = obj.BookStatusID;
        this.BookMSTModel.IsActive = obj.IsActive;
        this.BookMSTModel.BookTitleID = obj.BookTitleID;
        this.BookMSTModel.BookTitle = obj.BookTitle;
        this.BookMSTModel.BookTypeID = obj.BookTypeID;
        this.BookMSTModel.BookType = obj.BookType;
        this.BookMSTModel.AuthorID = obj.AuthorID;
        this.BookMSTModel.AuthorName = obj.AuthorName;
        this.BookMSTModel.PublicationID = obj.PublicationID;
        this.BookMSTModel.Publication = obj.Publication;
        this.BookMSTModel.BookEdditionID = obj.BookEdditionID;
        this.BookMSTModel.BookEddition = obj.BookEddition;
        this.BookMSTModel.PublicationYearID = obj.PublicationYearID;
        this.BookMSTModel.PublicationYear = obj.PublicationYear;
        this.BookMSTModel.Cost = obj.Cost;
        this.BookMSTModel.BookSerialNo = obj.BookSerialNo;
        this.BookMSTModel.BookSerialID = obj.BookSerialID;
        this.BookMSTModel.PublicationLocationID = obj.PublicationLocationID;
        this.BookMSTModel.PublicationLocation = obj.PublicationLocation;
        this.BookMSTModel.NoOfPages = obj.NoOfPages;
        this.BookMSTModel.NoOfCopies = obj.NoOfCopies;
        this.BookMSTModel.SubjectID = obj.SubjectID;
        this.BookMSTModel.Subject = obj.Subject;
        this.BookMSTModel.Series = obj.Series;
        this.BookMSTModel.ShelfLocation = obj.ShelfLocation;
        this.BookMSTModel.Remarks = obj.Remarks;
        this.BookMSTModel.BookStatusID = obj.BookStatusID;
        this.BookMSTModel.LibraryTypeID = obj.LibraryTypeID;
        this.BookMSTModel.BillNo = obj.BillNo;
        this.BookMSTModel.BillDate = obj.BillDate != null ? moment(obj.BillDate).format("DD-MMM-YYYY") : '';

    };
    GetAllBookGroup() {
        this.spinnerService.show();
        this.lookupservice.GetLookupsList('BookGroup', '').subscribe((data: any) => {
            this.BookGroup = data.LookupItems;
            this.spinnerService.hide();
        });
    };

    XLSDownload() {
        this.FilterModel.CurrentIndex = this.currentPage;
        this.FilterModel.PageSize = 0;
        this.spinnerService.show();
        this.libraryservice.GetAllBookMST(JSON.stringify(this.FilterModel)).subscribe((response: any) => {
            this.BookList1 = response.BookList1;
            if (this.BookList1 != null && response.BookList1.length > 0) {
                this.JSONToCsvConverterList(this.BookList1, 'Book_List', true);
            }
            this.spinnerService.hide();
        });
    }

    JSONToCsvConverterList(JSONData, ReportTitle, ShowLabel) {
        var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
        var CSV = '';
        if (ShowLabel) {
            var row = "";
            row += 'Sr. No.' + ',';
            row += 'Library Type' + ',';
            row += 'Book Status' + ',';
            row += 'Acc. No' + ',';
            row += 'Call No' + ',';
            row += 'Book Type' + ',';
            row += 'Title' + ',';
            row += 'Author' + ',';
            row += 'Publisher' + ',';
            row += 'Place of Publication' + ',';
            row += 'Year of Publication' + ',';
            row += 'Edition' + ',';
            row += 'Cost' + ',';
            row += 'No of Pages' + ',';
            row += 'No of Copies' + ',';
            row += 'ISBN' + ',';
            row += 'Subject' + ',';
            row += 'Language' + ',';
            row += 'Series' + ',';
            row += 'Shelf Location' + ',';
            row += 'Remarks' + ',';
            row += 'Bill No' + ',';
            row += 'Bill Date' + ',';
            row += 'Issuable' + ',';
            row = row.slice(0, -1);
            CSV += row + '\r\n';
        }
        for (var i = 0; i < arrayData.length; i++) {
            var sno = i + 1;
            var row = "";
            row += '"' + sno + '",';
            row += '"' + arrayData[i].LibraryType + '",';
            row += '"' + arrayData[i].BookStatus + '",';
            row += '"' + arrayData[i].BookSerialNo + '",';
            if (arrayData[i].CallNo != null) {
                row += '"' + arrayData[i].CallNo + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].BookType != null) {
                row += '"' + arrayData[i].BookType + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            row += '"' + arrayData[i].BookTitle + '",';
            row += '"' + arrayData[i].AuthorName + '",';
            if (arrayData[i].Publication != null) {
                row += '"' + arrayData[i].Publication + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].PublicationLocation != null) {
                row += '"' + arrayData[i].PublicationLocation + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].PublicationYear != null) {
                row += '"' + arrayData[i].PublicationYear + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].BookEddition != null) {
                row += '"' + arrayData[i].BookEddition + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Cost != null) {
                row += '"' + arrayData[i].Cost + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].NoOfPages != null) {
                row += '"' + arrayData[i].NoOfPages + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].NoOfCopies != null) {
                row += '"' + arrayData[i].NoOfCopies + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].ISBN != null) {
                row += '"' + arrayData[i].ISBN + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Subject != null) {
                row += '"' + arrayData[i].Subject + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Language != null) {
                row += '"' + arrayData[i].Language + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Series != null) {
                row += '"' + arrayData[i].Series + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].ShelfLocation != null) {
                row += '"' + arrayData[i].ShelfLocation + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Remarks != null) {
                row += '"' + arrayData[i].Remarks + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].BillNo != null) {
                row += '"' + arrayData[i].BillNo + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].BillDate != null) {
                row += '"' + arrayData[i].BillDate + '",';
            }
            else {
                row += '"' + '' + '",';
            }

            if (arrayData[i].IsIssuable == true) {
                row += '"' + 'Yes' + '",';
            }
            else {
                row += '"' + 'No' + '",';
            }
            row.slice(0, row.length - 1);
            CSV += row + '\r\n';
        }
        if (CSV == '') {
            alert('Invalid Data');
            return;
        }
        var FileName = ReportTitle + '_' + moment(new Date()).format("DD-MMM-YYYY");
        var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
        var csvURL = window.URL.createObjectURL(csvData);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', FileName + '.csv');
        tempLink.click();
    }
    JXLSDownload() {
        this.FilterModel.CurrentIndex = this.currentPage;
        this.FilterModel.PageSize = 0;
        this.spinnerService.show();
        this.libraryservice.GetAllBook(JSON.stringify(this.FilterModel)).subscribe((response: any) => {
            this.BookList1 = response.BookList1;
            if (this.BookList1 != null && response.BookList1.length > 0) {
                this.JSONToCsvConverterJournalList(this.BookList1, 'Journal_List', true);
            }
            this.spinnerService.hide();
        });
    }

    JSONToCsvConverterJournalList(JSONData, ReportTitle, ShowLabel) {
        var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
        var CSV = '';
        if (ShowLabel) {
            var row = "";
            row += 'Sr. No.' + ',';
            row += 'Library Type' + ',';
            row += 'Book Status' + ',';
            row += 'Acc. No' + ',';
            row += 'Title' + ',';
            row += 'Volume No' + ',';
            row += 'Issue No' + ',';
            row += 'Publisher' + ',';
            row += 'Place of Publication' + ',';
            row += 'Frequency' + ',';
            row += 'Cost' + ',';
            row += 'Language' + ',';
            row += 'Shelf Location' + ',';
            row += 'Remarks' + ',';
            row += 'Bill No' + ',';
            row += 'Bill Date' + ',';
            row += 'Issuable' + ',';
            row = row.slice(0, -1);
            CSV += row + '\r\n';
        }
        for (var i = 0; i < arrayData.length; i++) {
            var sno = i + 1;
            var row = "";
            row += '"' + sno + '",';
            row += '"' + arrayData[i].LibraryType + '",';
            row += '"' + arrayData[i].BookStatus + '",';
            row += '"' + arrayData[i].BookSerialNo + '",';
            if (arrayData[i].BookTitle != null) {
                row += '"' + arrayData[i].BookTitle + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].VolumeNo != null) {
                row += '"' + arrayData[i].VolumeNo + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].IssueNo != null) {
                row += '"' + arrayData[i].IssueNo + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Publication != null) {
                row += '"' + arrayData[i].Publication + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].PublicationLocation != null) {
                row += '"' + arrayData[i].PublicationLocation + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Frequency != null) {
                row += '"' + arrayData[i].Frequency + '",';
            }
            else {
                row += '"' + '' + '",';
            }

            if (arrayData[i].Cost != null) {
                row += '"' + arrayData[i].Cost + '",';
            }
            else {
                row += '"' + '' + '",';
            }

            if (arrayData[i].Language != null) {
                row += '"' + arrayData[i].Language + '",';
            }
            else {
                row += '"' + '' + '",';
            }

            if (arrayData[i].ShelfLocation != null) {
                row += '"' + arrayData[i].ShelfLocation + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Remarks != null) {
                row += '"' + arrayData[i].Remarks + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].BillNo != null) {
                row += '"' + arrayData[i].BillNo + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].BillDate != null) {
                row += '"' + arrayData[i].BillDate + '",';
            }
            else {
                row += '"' + '' + '",';
            }

            if (arrayData[i].IsIssuable == true) {
                row += '"' + 'Yes' + '",';
            }
            else {
                row += '"' + 'No' + '",';
            }
            row.slice(0, row.length - 1);
            CSV += row + '\r\n';
        }
        if (CSV == '') {
            alert('Invalid Data');
            return;
        }
        var FileName = ReportTitle + '_' + moment(new Date()).format("DD-MMM-YYYY");
        var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
        var csvURL = window.URL.createObjectURL(csvData);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', FileName + '.csv');
        tempLink.click();
    }
    CXLSDownload() {
        this.FilterModel.CurrentIndex = this.currentPage;
        this.FilterModel.PageSize = 0;
        this.spinnerService.show();
        this.libraryservice.GetAllBook(JSON.stringify(this.FilterModel)).subscribe((response: any) => {
            this.BookList1 = response.BookList1;
            if (this.BookList1 != null && response.BookList1.length > 0) {
                this.JSONToCsvConverterCDList(this.BookList1, 'CD_List', true);
            }
            this.spinnerService.hide();
        });
    }

    JSONToCsvConverterCDList(JSONData, ReportTitle, ShowLabel) {
        var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
        var CSV = '';
        if (ShowLabel) {
            var row = "";
            row += 'Sr. No.' + ',';
            row += 'Library Type' + ',';
            row += 'Book Status' + ',';
            row += 'Acc. No' + ',';
            row += 'Title' + ',';
            row += 'Author' + ',';
            row += 'Publisher' + ',';
            row += 'Place of Publication' + ',';
            row += 'CD Type' + ',';
            row += 'Cost' + ',';
            row += 'Shelf Location' + ',';
            row += 'Remarks' + ',';
            row += 'Bill No' + ',';
            row += 'Bill Date' + ',';
            row += 'Issuable' + ',';
            row = row.slice(0, -1);
            CSV += row + '\r\n';
        }
        for (var i = 0; i < arrayData.length; i++) {
            var sno = i + 1;
            var row = "";
            row += '"' + sno + '",';
            row += '"' + arrayData[i].LibraryType + '",';
            row += '"' + arrayData[i].BookStatus + '",';
            row += '"' + arrayData[i].BookSerialNo + '",';
            if (arrayData[i].BookTitle != null) {
                row += '"' + arrayData[i].BookTitle + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].AuthorName != null) {
                row += '"' + arrayData[i].AuthorName + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Publication != null) {
                row += '"' + arrayData[i].Publication + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].PublicationLocation != null) {
                row += '"' + arrayData[i].PublicationLocation + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].BookType != null) {
                row += '"' + arrayData[i].BookType + '",';
            }
            else {
                row += '"' + '' + '",';
            }

            if (arrayData[i].Cost != null) {
                row += '"' + arrayData[i].Cost + '",';
            }
            else {
                row += '"' + '' + '",';
            }

            if (arrayData[i].ShelfLocation != null) {
                row += '"' + arrayData[i].ShelfLocation + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].Remarks != null) {
                row += '"' + arrayData[i].Remarks + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].BillNo != null) {
                row += '"' + arrayData[i].BillNo + '",';
            }
            else {
                row += '"' + '' + '",';
            }
            if (arrayData[i].BillDate != null) {
                row += '"' + arrayData[i].BillDate + '",';
            }
            else {
                row += '"' + '' + '",';
            }

            if (arrayData[i].IsIssuable == true) {
                row += '"' + 'Yes' + '",';
            }
            else {
                row += '"' + 'No' + '",';
            }
            row.slice(0, row.length - 1);
            CSV += row + '\r\n';
        }
        if (CSV == '') {
            alert('Invalid Data');
            return;
        }
        var FileName = ReportTitle + '_' + moment(new Date()).format("DD-MMM-YYYY");
        var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
        var csvURL = window.URL.createObjectURL(csvData);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', FileName + '.csv');
        tempLink.click();
    }



    ngOnInit() {
        //this.GetCheckACCNo('');
        this.GetAllFrequency();
        //this.GetAllBook();           
        // this.GetItemType();
        this.GetBookTitle("");
        this.GetAllLibrary();
        this.GetAllBookStatus();
        this.GetAllAuthor('');
        this.GetAllPublication('');
        this.GetAllBookEddition('');
        this.GetAllLanguage('');
        this.GetAllSubject('');
        this.GetAllPublicationYear('');
        this.GetAllPublicationLocation('');
        this.GetAllBookType(1);
        var dtCurrent = new Date();
        var year = dtCurrent.getFullYear();
        this.YearList = [];
        var item = {
            ItemId: 0,
            ItemName: '---Select---'
        }
        this.YearList.push(item);
        for (var i = year + 1; i >= year - 25; i--) {
            item = {
                ItemId: i,
                ItemName: i.toString()
            }
            this.YearList.push(item);
        }
    }


 // Upload Book

 SelectedFileForUpload: any;
 selectFileforUpload(file) {
   this.SelectedFileForUpload = file[0];
 };
 BookNotUploaded=[];
 UploadBook() {
    if (confirm("Are you sure ? You want to upload. Please verify book.")) {
      this.BookNotUploaded=[];
      this.spinnerService.show();
      this.libraryservice.UploadBook(this.SelectedFileForUpload).subscribe((response: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
        this.BookNotUploaded=response.BookNotUploaded;
        if (response.webResponse.Status) {
          this.SelectedFileForUpload!=null
          this.fileUploader.nativeElement.value = null;
        }
        this.GetAllBook();
       
      });
    }
  }

}
